// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__Oagqy","notificationShow":"Notification_notificationShow__2u5Gu"};